import api from '..';

export type Payload = {
  venda_id: number;
  cliente_cpf: string;
};

export const requestInitM4UAcquisition = async (payload: Payload) => {
  const { data } = await api.post(`/core/vendas/iniciar-adesao-m4u/`, payload);

  return data;
};
